import { RpmLeaderboardEntry } from '../../models/TrainingLaunch';
import { TrainingRepository } from '../../repositories/TrainingRepository';

export class GetRpmLeaderboardUseCase {
  constructor(private trainingRepository: TrainingRepository) {}

  async execute(sortBy: string = 'rpm', limit: number = 50): Promise<RpmLeaderboardEntry[]> {
    return this.trainingRepository.getLeaderboard(sortBy, limit);
  }
}
